// Recovered compiled webpack factory 15075. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { $: () => n });
  let n = (t) => /^0[^.\s]+$/u.test(t);
}
